/**
 * EmptyPageState — Shown when the page has no sections.
 *
 * Friendly prompt with illustration and "Add Section" CTA.
 */

import { LayoutTemplate, Plus } from 'lucide-react'

interface EmptyPageStateProps {
  onAddSection: () => void
}

export function EmptyPageState({ onAddSection }: EmptyPageStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-md bg-gray-100">
        <LayoutTemplate className="h-8 w-8 text-gray-300" />
      </div>
      <h3 className="text-sm font-semibold text-gray-700">
        Your page is empty
      </h3>
      <p className="mt-1 text-xs text-gray-400 max-w-[220px]">
        Add sections like hero banners, product grids, and more to build your page.
      </p>
      <button
        onClick={onAddSection}
        className="mt-5 flex items-center gap-1.5 rounded-sm bg-sky-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-sky-600 active:bg-sky-700"
      >
        <Plus className="h-4 w-4" />
        Add Section
      </button>
    </div>
  )
}
